// removed by extract-text-webpack-plugin
module.exports = {"TimelineForm":"TimelineForm","form-type-checkbox":"form-type-checkbox","col-sm-10":"col-sm-10","btnSection":"btnSection"};


//////////////////
// WEBPACK FOOTER
// ./src/template/Docks/StudentInfo/Timeline/TimelineForm.scss
// module id = Va3t
// module chunks = 0